import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";

const DashboardActionMenu = ({ className, children }) => (
  <DataGrid className={className}>
    <DataGridItem big>{children}</DataGridItem>
  </DataGrid>
);

DashboardActionMenu.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
};

export default DashboardActionMenu;
